<template>
  <div class="tooltip-wrapper d-print-none" @click.stop.prevent ref="tooltipWrapper">
    <div
      class="tooltip"
      :class="{ active: this.showTooltip, 'tooltip--down': direction === 'down' }"
      ref="tooltip"
    >
      <div class="tooltip__header">
        <slot name="title"></slot>
      </div>
      <div class="tooltip__content">
        <slot name="content"></slot>
      </div>
    </div>
    <div
      class="tooltip-icon"
      @click.stop.prevent="toggleTooltip"
      @mouseenter="onMouseOver"
      @mouseleave="onMouseLeave"
    >
      <iconInfoBlack class="icon" v-if="infoIconColor === 'black'"></iconInfoBlack>
      <iconInfoWhite class="icon" v-if="infoIconColor !== 'black'"></iconInfoWhite>
    </div>
  </div>
</template>

<script>
import iconClose from '@/assets/icons/close-dark.svg'
import iconInfoBlack from '@/assets/icons/info-black.svg'
import iconInfoWhite from '@/assets/icons/info-white.svg'
import { device } from '@/vendor/civ2-js-utils'

export default {
  name: 'CiTooltip',
  components: {
    iconClose,
    iconInfoBlack,
    iconInfoWhite,
  },
  props: {
    infoIconColor: { type: String, default: 'black', required: false },
    direction: { type: String, default: 'up' },
  },
  data() {
    return {
      showTooltip: false,
    }
  },
  created() {
    window.addEventListener('touchstart', this.onClickOutside)
    window.addEventListener('click', this.onClickOutside)
  },
  methods: {
    onClickOutside(event) {
      if (!this.showTooltip) return

      if (
        (event.target !== this.$refs.tooltipWrapper &&
          !this.$refs.tooltipWrapper.contains(event.target)) ||
        this.$refs.tooltipClose.contains(event.target)
      ) {
        this.showTooltip = false
      }
    },

    toggleTooltip() {
      /* istanbul ignore else */
      if (device.hasTouch()) {
        this.showTooltip = !this.showTooltip
      }
    },

    onMouseOver() {
      /* istanbul ignore else */
      if (!device.hasTouch()) {
        this.showTooltip = true
      }
    },

    onMouseLeave() {
      /* istanbul ignore else */
      if (!device.hasTouch()) {
        this.showTooltip = false
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('touchstart', this.onClickOutside)
    window.removeEventListener('click', this.onClickOutside)
  },
}
</script>
<style lang="scss" scoped>
.no-touch .icon-close {
  display: none;
}

.tooltip-wrapper {
  color: black;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  display: inline-block;

  .tooltip {
    @include font('gotham_bookregular');
    @include font-format(0.875em, 1.125rem);

    background-color: $white;
    border-radius: 5px;
    border: 1px solid var(--primary-color);
    bottom: auto;
    display: none;
    left: 0;
    padding: 0;
    position: absolute;
    text-align: center;
    top: -15px;
    transform: translate3d(-17px, -100%, 0);
    width: 200px;
    z-index: 200;

    &::before {
      border-left: 12px solid transparent;
      border-top: 12px solid var(--primary-color);
      border-right: 12px solid transparent;
      content: '';
      display: block;
      height: 0;
      left: 15px;
      position: absolute;
      bottom: -12px;
      width: 0;
    }

    &::after {
      border-left: 10px solid transparent;
      border-top: 10px solid $white;
      border-right: 10px solid transparent;
      content: '';
      display: block;
      height: 0;
      left: 17px;
      position: absolute;
      bottom: -10px;
      width: 0;
    }

    &.tooltip--down {
      bottom: -15px;
      top: auto;
      transform: translate3d(-50%, 100%, 0);
      width: 250px;

      &::before {
        border-bottom: 12px solid var(--primary-color);
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 0;
        left: calc(50% - 2px);
        top: -12px;
      }

      &::after {
        border-top: 0;
        border-bottom: 10px solid;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        left: 50%;
        top: -10px;
      }
    }

    &.active {
      display: block;
    }
  }

  .tooltip-icon {
    height: 21px;
    position: relative;
    width: 21px;

    .icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 21px;
      height: 21px;
    }
  }

  .tooltip__header {
    @include font('gotham_mediumregular');

    position: relative;
    padding: 6px 25px 7px;
    background-color: var(--primary-color);
    color: $white;

    .icon-close {
      cursor: pointer;
      height: auto;
      position: absolute;
      right: 3px;
      top: 0;
      transform: scale(0.6);
    }
  }

  .tooltip__content {
    padding: 10px;

    p {
      margin: 0;
      padding: 0;
    }
  }
}
</style>
